import {GlobalVariables} from "../GlobalVariables";
import {ScrollSmoother} from "../LibrariesImport";

export default class SmoothScroll {
	static init() {
		GlobalVariables.smoother = ScrollSmoother.create({
			smooth: 0.8,
		});
	}
}

